<template>
  <router-link :to="`/${$store.state.lang}`" class="logo" aria-label="Return to the hompage">
    <strong>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 26.1">
        <path d="M12.4 11.3c-.3 0-.5.2-.5.5v1.9c0 .3.2.5.5.5h137.1c.3 0 .5-.2.5-.5v-1.9c0-.3-.2-.5-.5-.5H12.4z"/>
        <path d="M19 15.9l-.3.3c0 3.5-1.9 6.6-7.1 6.6-5 0-8-4.1-8-9.8s3-9.6 8.4-9.6c3.9 0 6.1 1.8 6.8 4.3l.3.3H22l.4-.4C21.6 4.1 18.8.2 12 .2 4.5.2 0 5.5 0 13s4.5 13 11.6 13c3.2 0 5.3-1.1 7.1-2.8h.4l.4 2.2.4.4H22l.4-.4v-9.1l-.4-.4h-3zm20.1 6.6l-.4-.4v-5.7l-.5-.5h-2.6l-.5.5v8.9l.3.4h16.1l.4-.4v-2.5l-.4-.4H39.1zm-.8-12.8l.4-.4V3.9l.4-.3h12.5l.4-.4V.7l-.4-.4H35.5l-.3.4v8.6l.4.4h2.7zm43.9 6.6l-.6-.4h-3.3l-.2.3c.6.6.9 1.5.9 2.7 0 2.8-2.5 3.9-5.7 3.9s-5.7-.6-6.7-2.4l-.5-.3h-1.4l-.4.4v1.8l.3.7c1.7 2.1 4.6 3.1 8.5 3.1 6.8 0 9.6-3.2 9.6-7.1-.1-1.1-.2-2-.5-2.7zM72.3 3.2c3.4 0 5.2.6 5.9 2l.5.4h1.7l.4-.4V3.6l-.2-.6c-1.3-2.2-4.5-3-7.9-3-6.4 0-8.9 3.6-8.9 6.8 0 1 .2 1.9.5 2.6l.6.3h3.2l.2-.4c-.7-.6-1-1.4-1-2.6 0-2.1 1.8-3.5 5-3.5zm24.2 12.7l-.6.6v8.9l.4.4h2.8l.4-.4v-8.9L99 16h-2.5zm2.6-6.2l.3-.4V.7L99 .3h-2.8l-.4.4v8.6l.4.4h2.9zm30.6 6.2h-3.2l-.1.4 1.4 3.6 2.1 5.4.4.4h2.2l.3-.4v-2.5l-2.6-6.5-.5-.4zm-15 0l-.4.4-2.6 6.5v2.5l.4.4h2.2l.3-.4 2.2-5.4 1.4-3.7-.1-.4h-3.4zm5.5-6.2l.4-.3 1.5-3.7h.4l1.5 3.7.4.3h3.2l.1-.1-3.5-8.8-.4-.4h-3.2l-.3.4-3.5 8.7.2.3h3.2z"/>
      </svg>
    </strong>
  </router-link>
</template>

<script>
export default {
  name: 'logo',
};
</script>

<style lang="scss" scoped>
.logo {
  strong,
  svg {
    display: inline-block;
    position: relative;
    height: inherit;
  }
}
</style>
